export default __webpack_public_path__ + "static/media/cr3.407b0817.png";